export const environment = {
  production: false,
  debug: true,
  apiUrl: 'https://collaboratorsapi-dev.inclub.world/api',
};
